import { Button, Table } from 'react-bootstrap';
import { ViewWrapper } from '../styles';
import { IPairedDonor } from '@nkr/store/index';

interface IProps {
    centerId: number,
    recipientId: number,
    isTransplanted: boolean,
    data: IPairedDonor[],
}

const Content = (props: IProps) => {
    return (
        <ViewWrapper horizontal>
            <div className='paired-donors'>
                <Table condensed bordered striped style={{ marginBottom: 5 }}>
                    <thead style={{ backgroundColor: '#ddd' }}>
                        <tr>
                            <th style={{ width: '11%' }}>Registered</th>
                            <th style={{ width: '11%' }}>Alias</th>
                            <th style={{ width: '11%' }}>Gender</th>
                            <th style={{ width: '11%' }}>Age</th>
                            <th style={{ width: '11%' }}>ABO</th>
                            <th style={{ width: '11%' }}>Will Travel</th>
                            <th style={{ width: '11%' }}>Exportable</th>
                            <th style={{ width: '11%' }}>Bridge or Chain Start</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {props.data.map(item =>
                            <tr key={'pd-' + item.id}>
                                <td>{item.registrationDate}</td>
                                <td>{item.alias}</td>
                                <td>{item.gender != '' ? item.gender : '--'}</td>
                                <td>{item.age}</td>
                                <td>{item.bloodType}</td>
                                <td>{item.isWillingToTravel ? 'Yes' : 'No'}</td>
                                <td>{item.isExportable ? 'Yes' : 'No'}</td>
                                <td>{item.isBridgeDonor ? 'Yes' : 'No'}</td>
                                <td>
                                    {item.centerId == props.centerId ? (
                                        <a href={'/center/' + item.centerId + '/donor/' + item.id + '/profile'}>Edit Donor</a>
                                    ) : (
                                        <span className='text-muted' title='This donor belongs to a different center and cannot be edited from here'>Edit Donor</span>
                                    )}
                                </td>
                            </tr>
                        )}
                    </tbody>
                </Table>

                {props.isTransplanted == false && (
                    <div className='pull-right'>
                        <Button bsStyle='primary' bsSize='sm' href={'/center/' + props.centerId + '/donor/add?recipientId=' + props.recipientId}>Add Donor</Button>
                    </div>
                )}
            </div>
        </ViewWrapper>
    );
}

export default Content;